const testimonials = [
  {
    name: "Staff Sergeant James R.",
    location: "Sheppard AFB, Wichita Falls TX",
    rating: 5,
    text: "Got PCS orders to Ramstein with 21 days to report. My wife's passport had expired and we had a six-month-old who needed a first passport. Fast Passport Center walked us through the infant application, reviewed everything, and got both passports back in seven business days. Thought we were going to have to defer the orders. Cannot thank them enough.",
    service: "Family Expedited Passports",
  },
  {
    name: "Dr. Linda K.",
    location: "Wichita Falls, TX",
    rating: 5,
    text: "I'm a physician at United Regional and was invited to present at a medical conference in Vienna with about three weeks notice. My passport had expired during COVID. Fast Passport Center had my renewal processed and back to me in six business days. Made my DFW flight with time to spare. Professional and completely stress-free.",
    service: "Passport Renewal",
  },
  {
    name: "The Martinez Family",
    location: "Iowa Park, TX",
    rating: 5,
    text: "Booked a Caribbean cruise out of Galveston for our family of four and realized our daughter's passport had expired. Called Fast Passport Center on a Monday, shipped documents Tuesday, and had the passport back by Friday. We sailed Saturday morning. If you're in North Texas and need a passport fast, these are the people to call.",
    service: "Emergency Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>)}
    </div>
  );
}

export default function WichitaFallsTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Wichita Falls Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Sheppard AFB families, North Texas professionals, and Wichita County residents who trusted Fast Passport Center.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">{t.service}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}